import locale from "localization";

export const premiumPayoutColumns = [
  { key: "monthAndYear", text: locale.monthAndYear, width: "24%"  },
  { key: "totalLiters", text: locale.totalLiters, width: "24%" },
  { key: "totalPayPeso", text: locale.totalLocqpay, width: "24%" },
  { key: "totalPremium", text: locale.totalPremium, width: "24%" },
  { key: "action", text: locale.action, width: "4%" },
];